import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import axios from "axios"
import { useEffect, useState } from "react"
import { NearbyShipsResponse } from "./usePrevetAPI"

interface UseFetchNearbyShipsArgs {
  imo?: string | number
  date: string | null
}

export function useFetchNearbyShips({ imo, date }: UseFetchNearbyShipsArgs) {
  const request = useAxiosRequest()
  const [result, setResult] = useState<{
    imo?: string | number
    date: string | null
    data?: NearbyShipsResponse
    loading: boolean
  }>({ date: null, loading: false })

  useEffect(() => {
    const controller = new AbortController()
    let active = true
    setResult({ imo, date, loading: Boolean(imo && date) })

    if (imo && date) {
      const fetchNearbyShips = async () => {
        try {
          const response = await request<unknown, NearbyShipsResponse>({
            signal: controller.signal,
            url: `${BASE_URL}/prevetting/nearby-ships`,
            params: { imo, date },
          })
          if (active) setResult({ imo, date, data: response?.data, loading: false })
        } catch (err: unknown) {
          if (active) setResult({ imo, date, loading: false })
          if (axios.isCancel(err)) return
          // Preserve the existing cleared-data behavior for request failures.
        }
      }
      fetchNearbyShips()
    }
    return () => {
      active = false
      controller.abort()
    }
    // Request identity is IMO/date; the request wrapper may change on render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imo, date])

  const current = result.imo === imo && result.date === date
  return {
    nearbyShipsData: current ? result.data : undefined,
    nearbyShipsLoading: current ? result.loading : Boolean(imo && date),
  }
}
